import { loadStripe } from "@stripe/stripe-js";

// The publishable key is public by design (it can only tokenize cards,
// never charge or read). Same live account as the backend's secret key
// (acct_1Sd1eFIP937A1IaW).
export const STRIPE_PUBLISHABLE_KEY =
    "pk_live_51Sd1eFIP937A1IaW5MBkfJxAteiIy3mt7BKKrUaqFM0Xg8j5JXHeSNaoR9ua24fuFu7UGu8pW7uLukWIa18SgEQ5001yJjnc34";

// Kicked off at module load of the checkout page; Elements awaits it.
export const stripePromise = loadStripe(STRIPE_PUBLISHABLE_KEY);
